'use strict';

var React = require('react');

var SvgProductReturnIcon = function SvgProductReturnIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.575 4.649a3.75 3.75 0 0 1 2.7-1.149h1.975a3.25 3.25 0 0 1 3.25 3.25v2.371c0 .766-.311 1.498-.863 2.029a.75.75 0 1 1-1.04-1.08c.258-.249.403-.591.403-.949v-2.371a1.75 1.75 0 0 0-1.75-1.75h-1.974a2.25 2.25 0 0 0-1.62.69l-4.254 4.417a1.25 1.25 0 0 0 .016 1.75l4.112 4.113a.75.75 0 1 1-1.06 1.06l-4.113-4.112a2.75 2.75 0 0 1-.036-3.852l4.254-4.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12a.75.75 0 0 0-1.5 0v.5a1.75 1.75 0 0 1-1.75 1.75h-.94l.22-.22a.75.75 0 1 0-1.06-1.06l-1.5 1.5a.75.75 0 0 0 0 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-.22-.22h.94a3.25 3.25 0 0 0 3.25-3.25v-.5Z"
  }));
};
SvgProductReturnIcon.displayName = "ProductReturnIcon";

exports.SvgProductReturnIcon = SvgProductReturnIcon;
